import React from 'react';
import { ReactComponent as NotificationAlertSvg } from '../../../assets/images/notification_alert.svg';

const NotificationTutorialImg = props => {
  return <NotificationAlertSvg {...props} />;
};

export default NotificationTutorialImg;
